"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DisplayModalIfEmptyLanguages = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _ModalDialog = _interopRequireDefault(require("@jobmatchme/ui/es/components/ModalDialog"));

var _reactI18next = require("react-i18next");

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _notistack = require("notistack");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _getConfig = _interopRequireDefault(require("@jobmatchme/profile-components/es/resources/getConfig"));

var _Profile = require("../../provider/Profile");

var _Vertical = require("../../provider/Vertical");

var _Matches = require("../../provider/Matches");

var _SingleEdit = _interopRequireDefault(require("@jobmatchme/profile-components/es/components/Edit/SingleEdit"));

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var translateNs = 'pc-matching:LanguageSkillsOverlay';

var LanguageSkillsModal = function LanguageSkillsModal() {
  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useSnackbar = (0, _notistack.useSnackbar)(),
      enqueueSnackbar = _useSnackbar.enqueueSnackbar;

  var _useContext = (0, _react.useContext)(_Vertical.VerticalContext),
      vertical = _useContext.vertical;

  if (typeof vertical === 'undefined') throw new Error('Cannot render dialog without a known vertical');
  var config = (0, _getConfig.default)(vertical)('pc');

  var _useState = (0, _react.useState)(true),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var profileContext = (0, _react.useContext)(_Profile.ProfileContext);

  var _useContext2 = (0, _react.useContext)(_Matches.MatchesActionsContext),
      fetchMatches = _useContext2.fetchMatches,
      executeWhileLoading = _useContext2.executeWhileLoading;

  var _useContext3 = (0, _react.useContext)(_Profile.ProfileActionsContext),
      updateProfile = _useContext3.updateProfile;

  var onProfileUpdate = function onProfileUpdate(profile) {
    return executeWhileLoading([function () {
      return updateProfile(profile).then(function (updatedProfile) {
        enqueueSnackbar(t("".concat(translateNs, ".Validation.Success.changes")), {
          variant: 'success',
          anchorOrigin: {
            vertical: 'top',
            horizontal: 'right'
          }
        });
        handleClose();
        return updatedProfile;
      });
    }, fetchMatches]);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalDialog.default, {
    open: open,
    opacity: 0.5,
    noPadding: true,
    name: "languageSkillsOverlay",
    id: 'languageSkillsOverlay',
    mobileHeight: "auto",
    showDividers: false,
    verticalMobilePosition: 'bottom',
    onClose: handleClose,
    dialogActions: false,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
      className: _styleModule.default.content,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SingleEdit.default, {
          config: config,
          valueName: "languages",
          translationOverride: {
            hint: "".concat(translateNs, ".hint")
          },
          profile: profileContext,
          onPropertySave: onProfileUpdate,
          btnText: t("".concat(translateNs, ".saveBtn")),
          incomplete: false,
          specialDefaults: undefined
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
          className: _styleModule.default.footer,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
            component: "div",
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
              onClick: handleClose,
              component: "span",
              className: _styleModule.default.fakeLink,
              children: t("".concat(translateNs, ".footer.closeText"))
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
            component: "span",
            children: t("".concat(translateNs, ".footer.text"))
          })]
        })]
      })
    })
  }, 'erase');
};

var _default = /*#__PURE__*/(0, _react.memo)(LanguageSkillsModal);

exports.default = _default;

var DisplayModalIfEmptyLanguages = function DisplayModalIfEmptyLanguages() {
  var _useContext4 = (0, _react.useContext)(_Profile.ProfileStatusContext),
      loaded = _useContext4.loaded;

  var _useContext5 = (0, _react.useContext)(_Profile.ProfileContext),
      languages = _useContext5.languages;

  return loaded && (typeof languages === 'undefined' || languages.length === 0) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(LanguageSkillsModal, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
};

exports.DisplayModalIfEmptyLanguages = DisplayModalIfEmptyLanguages;